.message {
  display: flex;
  flex-direction: column;

  max-width: 560px;
  margin-top: 11px;

  text-align: left;
  margin-left: auto;
  margin-right: 0;

  &.caseworker {
    margin-right: auto;
    margin-left: 0;

    .messageBody {
      background-color: #f3f4f6;
      margin-left: 0;
    }

    .messageContainer {
      margin-right: auto;
      margin-left: 0;
    }

    .messageRow {
      flex-direction: row;
      justify-content: flex-start;
    }
  }

  .messageContainer {
    margin-left: auto;
    margin-bottom: 0.5rem;
  }

  .messageInfo {
    text-align: right;
    font-size: 14px;
    font-weight: 500;
    color: #606772;
  }

  .messageRow {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-direction: row-reverse;
  }

  .messageBody {
    background-color: #8ad3db;
    border-radius: 8px;
    padding: 0.75rem 1rem;

    white-space: pre-line;
    width: fit-content;
    line-break: normal;
    margin-left: auto;
  }

  .messageBody:empty {
    display: block;
    padding: 0.75rem 1rem;
    height: 3rem;
  }
}
